// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue                  from 'vue'
import App                  from './App'
import VueRouter            from "vue-router"
import router               from './router'
import axios                from 'axios'
import VueTheMask           from 'vue-the-mask'
import VueMoney             from 'v-money'
import mobile               from 'mobile-device-detect';
// import Autocomplete         from '@trevoreyre/autocomplete-vue'
// import '@trevoreyre/autocomplete-vue/dist/style.css'
// import CKEditor from '@ckeditor/ckeditor5-vue2';
// import VueSuggestion        from 'vue-suggestion'

// import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

var url                     = "https://app.xegosuperonline.com.br";
// var url                     = "http://localhost:8081";
// Vue.use(CKEditor)
Vue.use(VueRouter)
Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(mobile)
// Vue.use(Autocomplete)
// Vue.use(VueSuggestion)
window.axios                = axios
axios.defaults.baseURL      = url;
Vue.config.ignoredElements = [/^ion-/]
Vue.config.productionTip    = false
window._app;

if (!window.cordova && location.hostname != "localhost") {
    window.console.log      = function(){};
}
if (window.cordova || location.hostname != "localhost") {
    axios.defaults.timeout  = 60000;
}


/* eslint-disable no-new */
new Vue({
  	el:                  '#app',
  	router,
  	components: {
        App
    },
  	template:            '<App/>',

    data: {
        "titulo":       null,
        "backFn":       null,
        "logged":       false,
        "cordova":      window.cordova || null,
        "user":  {
            "_cod":     null,
            "_token":   null,
            "tipo":     null
        },
        "form":         null,
        "mobile":       mobile,
        "modal":  {
            
        },
        "tmp":  {
            
        },
        "config": {
            "url":      url,
            "googleAnalytics": {
                "id":   ""
            },
            "pusher": {
                "key": ""
            },
            "money": {
                "decimal":            ',',
                "thousands":          '.',
                "prefix":             '',
                "suffix":             '',
                "precision":          2,
                "masked":             false
            }      
        }
    },
    methods: {
        initialize: function() {
            console.log("app.initialize()");
            var self = this;

            // gtag('js', new Date());
            // gtag('config', self.config.googleAnalytics.id);

            window.confirmWeb   = window.confirm;
            window.confirm      = function(msg, callback) {
                if (window.confirmWeb(msg)) {
                    callback();
                }
            }

            var self        = this;
            window.__app    = self;
            self.fixClass();

        },
        scrollTop: function() {
            console.log("scrollTop()")
            setTimeout(function() {
                $("body")[0].scrollTo({
                    top:            0
                });     
            }, 100);
        },          
        go: function(route, data) {
            console.log("app.go()", route, data)
            var self = this;

            if (!data) {
                data = {};
            } else {
                data = JSON.parse(data);
            }
            self.$router.push({ 
                name:       route,
                query:      data
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },                
        back: function() {
            var self = this;
            console.log("back()", self, window.history.length);
            if (window.history.length > 3) {
                $(".content-load .dashboard-container").fadeOut(100);                
            }

            if (self.$route.meta.auth == false) {
                window.history.go(-3);
            } else {
                window.history.back();
            }

        },
        fixClass: function() {
            var self = this;
            if (self.$route) {
                $("body").attr("class", "");
                if (self.$route.name) {
                    $("body").addClass("current-page-" + self.$route.name.toLowerCase());  
                }
            }
        },

        redirect: function(route) {
            console.log("app.redirect()", route)
            var self = this;
            self.$router.push({ 
                path:       route
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },         
        setUser: function(usuario) {
            var self    = this;
            return new Promise(function(resolve, reject) {
                window.localStorage.setItem("_usuario", JSON.stringify(usuario));
                self.logged    = true;
                self.user   = usuario;

                if (usuario.tipo == "entregador" && !usuario.imagemDoc) {
                    setTimeout(function() {
                        self.go("Cadastro2");
                    }, 500);
                } else if (usuario.tipo == "entregador" && usuario.imagemDoc) {
                    setTimeout(function() {
                        self.go("Cadastro3");
                    }, 500);                    
                }

                resolve(usuario);

            });
        },
        getUser: function(force) {
            var self        = this;
            console.log("getUser()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUser() response", response);
                    self.setUser(response.data.result);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getUser() error", error);
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.logout();
                        }
                    }
                    
                    reject(error);
                    
                });   
            });   
        },                           
        checkLogin: function() {
            var self    = this;
            if (!window.localStorage.getItem("_usuario")) {
                return false;
            } else {
                var usuario = null;
                try {
                    usuario = JSON.parse(window.localStorage.getItem("_usuario"));
                    self.setUser(usuario);
                    self.getUser();

                    return true;
                } catch(err) {
                    console.log("checkLogin() error parse", err);
                    return false;
                }
            }
        },
        logout: function() {
            var self = this;
            $(".mm-menu").hide();
            $("#mm-blocker").hide();            
            loading.show();
            window.localStorage.clear();
            // self.go("Introducao");
            // setTimeout(function() {

                location.reload();
            // }, 1000);
        },        
        openModal: function(nome) {
            var self        = this;

            console.log("openModal()", nome)

            // loading.show();

            self.modal[nome]   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', '', 'escape'],
                closeLabel:     "",
                cssClass:       [(nome), "modal-default"]
            });   

            setTimeout(function() {
                self.modal[nome].setContent(document.querySelector('#' + nome).innerHTML);      
                self.modal[nome].open();
                // loading.hide();
                setTimeout(function() {
                    $("." + nome).append('<a class="close" onclick=\'window.__app.modal["' + nome + '"].close();\'><i><ion-icon name="close-outline"></ion-icon></i></a>');    
                }, 100);
            }, 500);        
        },
    },
    created: function() {
    	console.log("APP created")
    	var self = this;
        self.initialize();  
    	if (window.__usuario) {
    		self.setUser(window.__usuario);
    	}
    },
	watch:{
	    $route (to, from){
	        var self = this;
            self.fixClass();
	        setTimeout(function() {
                self.scrollTop();                
                // gtag('config', self.config.googleAnalytics.id, {'page_title': to.meta.title});                 

	        }, 100);
	    }, 
	},
    on: {
        
    }      	
})



// WEBPACK FOOTER //
// ./src/main.js